/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CoverageStatus,
  CoverageStatusFromJSON,
  CoverageStatusFromJSONTyped,
  CoverageStatusToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface CoverageStatusIEnumerableControllerResponse
 */
export interface CoverageStatusIEnumerableControllerResponse {
  /**
   *
   * @type {Array<CoverageStatus>}
   * @memberof CoverageStatusIEnumerableControllerResponse
   */
  data?: Array<CoverageStatus> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof CoverageStatusIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function CoverageStatusIEnumerableControllerResponseFromJSON(
  json: any,
): CoverageStatusIEnumerableControllerResponse {
  return CoverageStatusIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function CoverageStatusIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CoverageStatusIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(CoverageStatusFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function CoverageStatusIEnumerableControllerResponseToJSON(
  value?: CoverageStatusIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(CoverageStatusToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
